import "./CommentCardSkeleton.css";

export default function CommentCardSkeleton() {
  return (
    <div className="dashboard-comment-skeleton-card">

      {/* Header */}
      <div className="dashboard-comment-skeleton-header">

        {/* Image */}
        <div className="dashboard-comment-skeleton-image skeleton-shimmer" />

        {/* Meta */}
        <div className="dashboard-comment-skeleton-meta">

          <div className="dashboard-comment-skeleton-status skeleton-shimmer" />

          <div className="dashboard-comment-skeleton-date skeleton-shimmer" />

        </div>

        {/* Arrow */}
        <div className="dashboard-comment-skeleton-arrow skeleton-shimmer" />

      </div>

    </div>
  );
}